import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CASE_STUDY_GENERATE_SEARCH_MASTER, CASE_STUDY_LIST_MASTER, API_URL_INPUT_MASTER, CASE_STUDY_MASTER_ADD_EDIT, CASE_STUDY_GENERATE_DISPLAY_MASTER, DELETE_CASE_STUDY_MASTER, GET_LST_PUB_CASE_STUDY_DATA, API_URL_DIC_LISTS, API_URL_GET_LIST_POSTALS_INITIAL } from 'manager/http-constants';
import { CASE_STUDY_M601_TEMPLATE } from 'manager/template-constant';
import { GenerateDisplay } from 'src/app/shared/generate/generate-display/generate-display-information/generate-display-information';
import { GenerateDisplayComponent } from 'src/app/shared/generate/generate-display/generate-display.component';
import { GENERATE_INPUT_TYPE } from 'src/app/shared/generate/generate-input/constant';
import { GenerateInputComponent } from 'src/app/shared/generate/generate-input/generate-input.component';
import { DeleteDialogComponent } from 'src/app/shared/html-parts/delete-dialog/delete-dialog.component';
import { ExportFileService } from 'src/app/shared/html-parts/export-file/export-file.service';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { CASE_STUDY_CONSTANT } from './constant';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CONSTANT, DICID_NUMBER } from 'src/app/shared/constant/constant';
import { PlatformComponent } from '../../platform.component';
import { LoginService } from 'src/app/shared/service/login.service';

@Component({
  selector: 'app-m601',
  templateUrl: './m601.component.html',
  styleUrls: ['../master.component.scss', '../../platform.component.scss', './m601.component.scss']
})
export class M601Component extends PlatformComponent implements OnInit {
  m601SearchForm: FormGroup = this.formBuilder.group({
    case_study_implementation_city: [],

    free_word: [],
  });
  // 課題・ソリューション種別のAccordion開閉フラグ
  accordion_free_word: boolean = false;
  showSearch: boolean = true;
  // 会員種別のAccordion開閉フラグ
  accordion_case_study_implementation_city: boolean = false;
  /** 詳細画面 */
  @ViewChild(GenerateDisplayComponent)
  generateDisplayItemsComponent: GenerateDisplayComponent;

  /** 新規登録、編集、複製画面 */
  @ViewChild(GenerateInputComponent)
  generateInputComponent: GenerateInputComponent;

  /** 削除ダイアログ */
  @ViewChild(DeleteDialogComponent)
  deleteDialogComponent: DeleteDialogComponent;

  // 検索項目生成エンドポイント
  public searchEndPoint: string = CASE_STUDY_GENERATE_SEARCH_MASTER;

  // 検索項目生成テンプレートID
  public searchTemplateId: number = CASE_STUDY_M601_TEMPLATE.SEARCH_TEMPLATE_ID;

  /* 画面用プロパティ */
  // 画面ヘッダー情報格納先
  columnOrder: any[] = new Array();

  // 画面検索結果一覧格納先
  searchResultsList: any[] = new Array();
  postalNoList: any[]
  // 検索条件保持
  generateSearchItems: Object;

  sessionTagName: string = "c201SearchConditions";
  // set first page = 1 
  pages: number = 0;
  innerWidth: any;
  checkMobile: boolean = false;
  isShowSearchMobile: boolean = false;
  m601 = true;
  isScroll: boolean = false;

  @ViewChild("dv")
  dv: DataView;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    public datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private changeDetector: ChangeDetectorRef,
    private exportFileService: ExportFileService,
    public loginService: LoginService,
    private router: Router
  ) {
    super(route, commonService, dbOperationService, loadingState, loginService);

  }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart();

    this.getSpecCodeList(
      DICID_NUMBER.MUNICIPALITIES,
    );
    /* ヘッダー情報取得処理(画面用) */
    this.dbOperationService
      .getHeaderList(CASE_STUDY_M601_TEMPLATE.SEARCH_RESULTS_TEMPLATE_ID)
      .subscribe((response) => {
        if (this.innerWidth > 450) {
          this.columnOrder = response.body
        }
        else {
          this.columnOrder = response.body.slice(0, 4);
          // let temp = this.columnOrder.pop()
          // this.columnOrder.unshift(temp)
          this.checkMobile = true
        }
      });

    // 検索処理を実施
    this.getResultCaseStudyDataList();
  }

  /**
   * 検索処理
   * @param generateSearchItems 検索条件
   */
  public searchResult(generateSearchItems?: Object) {
    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.loadStart(CASE_STUDY_LIST_MASTER);

    // CSV出力用に検索条件を保持
    this.generateSearchItems = generateSearchItems;

    /* 課題・ソリューション一覧取得処理(画面用) */
    this.dbOperationService
      .getForkJoinData(
        CASE_STUDY_CONSTANT.TABLE,
        CASE_STUDY_LIST_MASTER,
        CASE_STUDY_M601_TEMPLATE.SEARCH_RESULTS_TEMPLATE_ID,
        generateSearchItems,
        true
      )
      .subscribe((response) => {
        // コード値の一覧情報が存在するか否か
        if (!this.commonService.checkNoneResponse(response)) {
          // 課題・ソリューション一覧情報のJSONをオブジェクトに格納する
          this.searchResultsList = response.body;
        } else {
          this.searchResultsList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, CASE_STUDY_LIST_MASTER);

        // return to first page
        this.pages = 0;
      });
  }

  /**
  * check overflow of element
  * @param el html element of list 
  * @returns 
  */
  isOverflow(el: HTMLElement): boolean {
    const curOverflow = el.style.overflow;
    if (!curOverflow || curOverflow === "visible")
      el.style.overflow = "hidden";
    const isOverflowing = el.clientWidth < el.scrollWidth
      || el.clientHeight < el.scrollHeight;
    el.style.overflow = curOverflow;
    return isOverflowing;
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
  /**
 * 新規登録画面表示
 */
  public new() {
    this.router.navigate(["pages/platform/c502"]);
  }

  /**
   * 編集画面表示
   * @param pkeyId IDコード(クリックされたID)
   */
  public edit(pkeyId: string) {
    this.router.navigate(["pages/platform/c461/edit"], { queryParams: { case_study_id: pkeyId } });
    // 編集画面表示
    // this.generateInputComponent.initial(
    //   GENERATE_INPUT_TYPE.EDIT,
    //   API_URL_INPUT_MASTER,
    //   CASE_STUDY_GENERATE_DISPLAY_MASTER,
    //   CASE_STUDY_MASTER_ADD_EDIT,
    //   CASE_STUDY_M601_TEMPLATE.INPUT_TEMPLATE_ID,
    //   pkeyId
    // );
  }
  /**
   * 複製画面表示
   * @param pkeyId IDコード(クリックされたID)
   */
  public duplicate(pkeyId: string) {
    this.router.navigate(["pages/platform/c461/duplicate"], { queryParams: { case_study_id: pkeyId } });
  }
  /**
  * 詳細情報画面表示
  * @param pkeyId IDコード(クリックされたID)
  */
  protected detail(pkeyId: string) {
    // 詳細画面表示
    let generateDisplay: GenerateDisplay = new GenerateDisplay();
    generateDisplay.endPoint = CASE_STUDY_GENERATE_DISPLAY_MASTER;
    generateDisplay.templateId = CASE_STUDY_M601_TEMPLATE.OUTPUT_TEMPLATE_ID;
    this.generateDisplayItemsComponent.initial(generateDisplay, pkeyId);
  }

  /**
* 削除処理
* @param pkeyId IDコード(クリックされたID)
*/
  public delete(pkeyId: string) {
    const title = "連携事例"
    // 削除ダイアログにより削除処理
    this.deleteDialogComponent.deleteDialog(
      DELETE_CASE_STUDY_MASTER,
      this.columnOrder[0].header,
      pkeyId,
      title
    );
  }

  /**
   * プライマリーカラムを取得
   */
  protected getPkeyColumn(): string {
    return this.commonService.getPkeyColumn(this.columnOrder);
  }

  /**
 * 再検索処理＆データ置換
 * @param pkeyId コード値
 */
  public searchReplacement(pkeyId: string) {
    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.loadStart(CASE_STUDY_LIST_MASTER);


    // 返却されたコード値が存在するか否か
    if (null == pkeyId || undefined == pkeyId) {
      // 返却されたコード値が存在しない場合

      // 検索処理を実施
      this.searchResult();

      return;
    }
    const colId = this.checkMobile ? 1 : 0;
    // 営業日マスタ一覧取得処理(画面用)
    this.dbOperationService
      .getSingleData(
        CASE_STUDY_LIST_MASTER,
        CASE_STUDY_M601_TEMPLATE.SEARCH_RESULTS_TEMPLATE_ID,
        this.columnOrder[0].field,
        pkeyId
      )
      .subscribe((response) => {

        // コード値の一覧情報が存在するか否か
        if (this.commonService.checkNoneResponse(response)) {
          // 一覧情報が存在しない場合

          // 検索結果一覧から該当データを削除
          this.searchResultsList = this.searchResultsList.filter(
            (val) => val[this.columnOrder[0].field] !== pkeyId
          );

          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, CASE_STUDY_LIST_MASTER);
        } else {
          // 一覧情報が存在する場合

          // 検索結果一覧格納先から対象のデータの行数を抽出
          const indexTargetData = this.searchResultsList.indexOf(
            this.searchResultsList.find((results) => {
              return results[this.columnOrder[0].field] === pkeyId;
            })
          );

          // 検索結果一覧情報のJSONをオブジェクトに置換する
          this.searchResultsList.splice(indexTargetData, 1, response.body[0]);

          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, CASE_STUDY_LIST_MASTER);
        }
      });
  }
  public checkSetConditions(conditions: any): boolean {
    // 検索条件が存在するかチェック
    if (conditions === undefined || conditions === null) {
      return false;
    } else {
      // 検索条件が設定されているかチェック
      if (
        conditions["free_word"] ||
        conditions["agenda_kbn"] ||
        conditions["class_id"] ||
        conditions["category"] ||
        conditions["prefectures"] ||
        conditions["strdate"] ||
        conditions["enddate"] ||
        conditions["industry_id"] ||
        conditions["sdgs_goal"]
      ) {
        return true;
      }
    }
    return false;
  }
  public getListPostalsInitial(): void {
    this.postalNoList = new Array();
    this.loadingState.loadStart(API_URL_GET_LIST_POSTALS_INITIAL);

    this.dbOperationService
      .getNoTemplateData(API_URL_GET_LIST_POSTALS_INITIAL, {}, true)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.postalNoList = response.body;
        } else {
          this.postalNoList = new Array();
        }

        this.loadingState.loadSleepEnd(0.3, API_URL_GET_LIST_POSTALS_INITIAL);
      });
  }

  /**
 * カテゴリ大項目
 * @param event チェック状態
 * @param list チェック対象小項目リスト
 */
  public checkLargeCategory(
    type: string,
    list: any,
    controlName: string
  ): void {
    // 画面.検索フォーム.カテゴリを取得
    let getList = this.m601SearchForm.get(controlName).value;

    // チェック対象小項目リストからコード値のみ取得
    let spCodeList;
    spCodeList = this.commonService.createArrayGetArrayObject(
      list,
      "sp_code"
    );
    let result = [];
    // 該当のカテゴリコードを全て削除してresult変数に格納
    if (getList) {
      result = getList.filter((value) => !spCodeList.includes(value));
    }

    // チェック状態の判定

    // チェック状態の場合
    if (type == "checkAll") {
      // result変数に選択したカテゴリコードリストを追加
      result = result.concat(spCodeList);
    } else {
      result = result.filter((val) => !spCodeList.includes(val));
    }

    // 画面.検索フォーム.地域に設定
    this.m601SearchForm.get(controlName).setValue(result);
  }
  /**
 * アコーディオン表示フラグ設定
 */
  public setAccordionFlg(formVal: any): void {
    // 会員種別
    this.accordion_case_study_implementation_city =
      formVal.case_study_implementation_city != null && formVal.case_study_implementation_city?.length != 0 ? true : false;
  }
  isDisabledTab(controlName) {
    const value = this.m601SearchForm.get(controlName).value;
    if (value == null) {
      return false;
    } else if (value.length > 0) return true;
    else return false;
  }
  /**
 * 課題・ソリューション結果を取得
 */
  public getResultCaseStudyDataList(screenSearchFlg?: boolean): void {
    // 画面.検索フォームから検索条件を取得
    // ※値渡し
    let m601SearchForm: any = JSON.parse(
      JSON.stringify(this.m601SearchForm.value)
    );

    // 検索フォームが空の場合、セッションに保持している検索条件を設定
    if (!this.checkSetConditions(m601SearchForm) && !screenSearchFlg) {
      let sessionSearchForm = JSON.parse(
        sessionStorage.getItem(this.sessionTagName)
      );
      // セッションに値がなければ設定しない
      if (this.checkSetConditions(sessionSearchForm)) {
        // 画面の検索条件に反映する
        this.m601SearchForm.setValue(sessionSearchForm);
        // 検索条件に設定する
        m601SearchForm = JSON.parse(JSON.stringify(this.m601SearchForm.value));
        // 検索条件を元にアコーディオンの開閉フラグを設定
        this.setAccordionFlg(m601SearchForm);
      }
    }

    // 配列をカンマ区切り変換
    {
      m601SearchForm.free_word = m601SearchForm.free_word
        ? m601SearchForm.free_word.toString().trim()
        : CONSTANT.EMPTY_STRING;
      m601SearchForm.case_study_implementation_city = m601SearchForm.case_study_implementation_city
        ? m601SearchForm.case_study_implementation_city.toString()
        : CONSTANT.EMPTY_STRING;
    }
    const endpoint = GET_LST_PUB_CASE_STUDY_DATA;
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(CASE_STUDY_LIST_MASTER);

    this.dbOperationService
      .getForkJoinData(
        CASE_STUDY_CONSTANT.TABLE,
        CASE_STUDY_LIST_MASTER,
        CASE_STUDY_M601_TEMPLATE.SEARCH_RESULTS_TEMPLATE_ID,
        m601SearchForm,
        true
      )
      .subscribe((response) => {
        // コード値の一覧情報が存在するか否か
        if (!this.commonService.checkNoneResponse(response)) {
          // 課題・ソリューション一覧情報のJSONをオブジェクトに格納する
          this.searchResultsList = response.body;
        } else {
          this.searchResultsList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, CASE_STUDY_LIST_MASTER);

        // return to first page
        this.pages = 0;
      });
    
    this.m601SearchForm.get("free_word")?.setValue(m601SearchForm.free_word);
  }

  addScroll(event: any) {
    this.isScroll = event;
  }
}
